import getParams from '../Utils/getParams'
import { getSubValuations } from '../../../../../HttpRequests/subValuations'
import { setSubValuations } from '../State/subValuations'
import { startFetching, finishFetching } from '../State/fetching'
import { setPagination } from '../State/pagination'
import handleException from '../../../../../Core/Helpers/handleException'

export default () => async (dispatch, getState) => {

  const state = getState()

  const { pagination } = state.screens.Subbies.SubValuations

  const params = getParams(state)

  params.include = [
    'subcontractor',
    'project.clientSite.client',
    'user',
  ].join(',')

  params.append = 'reference,last_valuation,sub_project'

  params['page[number]'] = pagination.pageNumber
  params['page[size]'] = pagination.pageSize

  dispatch(startFetching())

  try {

    const response = await getSubValuations({ params })

    dispatch(setSubValuations(response.data.rows))

    dispatch(setPagination({
      pageNumber: response.data.pagination.current_page,
      pageSize: response.data.pagination.per_page,
      total: response.data.pagination.total,
    }))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(finishFetching())

  }

}
